<template>
    <div class="c-modal-scan">
        <b-modal :title="Core.Definition.getDefinition('Lecture')" class="modal-danger" v-model="dataShow" :hide-footer="true" cancel-variant="light">
            <InputScan
                    ref="payment"
                    v-model="dataValue"></InputScan>
        </b-modal>
    </div>
</template>

<script>
    import InputScan from './InputScan'
    export default {
        name: 'ModalScan',
        extends: InputScan,
        components: {
            InputScan,
        },
        props: {},
        watch: {
            value: {
                handler(val) {
                    this.dataValue = val
                },
                deep: true
            },
            dataValue: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                   return this.dataShow
                }
            }
        },
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false,
                dataValue: ''
            }
        },
        methods: {
        }
    }
</script>
